import { render, staticRenderFns } from "./QuestionAdd.vue?vue&type=template&id=37ac039a&scoped=true"
import script from "./QuestionAdd.vue?vue&type=script&lang=ts"
export * from "./QuestionAdd.vue?vue&type=script&lang=ts"
import style0 from "./QuestionAdd.vue?vue&type=style&index=0&id=37ac039a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac039a",
  null
  
)

export default component.exports